import React, { FC } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

import { PrimaryButton } from "../../elements/Button";

type CampaignsEmptyStateProps = {
  onCreateCampaign?: () => void;
};

const Root = styled("div")({
  padding: "56px 32px",
  textAlign: "center",
});

const IconWrap = styled("div")(({ theme }: { theme: Theme }) => ({
  width: 56,
  height: 56,
  borderRadius: 14,
  background: theme.palette.brand.gray100,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 16,
  border: `1px solid ${theme.palette.brand.gray200}`,
}));

const Title = styled("h3")(({ theme }: { theme: Theme }) => ({
  margin: 0,
  fontSize: 15,
  fontWeight: 600,
  color: theme.palette.brand.gray700,
}));

const Description = styled("p")(({ theme }: { theme: Theme }) => ({
  margin: "6px 0 20px",
  fontSize: 13,
  color: theme.palette.brand.gray500,
}));

const PlusIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const TargetIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </svg>
);

const TableBox = styled("div")(({ theme }: { theme: Theme }) => ({
  background: theme.palette.brand.white,
  borderRadius: 10,
  border: `1px solid ${theme.palette.brand.gray200}`,
  overflow: "hidden",
}));

const CampaignsEmptyState: FC<CampaignsEmptyStateProps> = ({ onCreateCampaign }) => (
  <TableBox>
    <Root>
      <IconWrap>
        <TargetIcon />
      </IconWrap>
      <Title>No campaigns yet</Title>
      <Description>Launch your first campaign to start reaching your audience.</Description>
      <PrimaryButton type="button" onClick={onCreateCampaign}>
        <PlusIcon />
        Create Campaign
      </PrimaryButton>
    </Root>
  </TableBox>
);

export default CampaignsEmptyState;
